// extracted by mini-css-extract-plugin
module.exports = {"link":"SignetOverviewPageLink-module-link"};